"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedStyle = exports.getHoverIndicatorStyle = exports.backgroundStyle = exports.activeStyle = void 0;

var _styledComponents = require("styled-components");

var _color2 = require("./color");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var backgroundStyle = function backgroundStyle(backgroundArg, theme) {
  if (_typeof(backgroundArg) === 'object') {
    var styles = [];

    if (backgroundArg.image) {
      var color = 'inherit';
      styles.push((0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-image: ", ";\n        background-repeat: ", ";\n        background-position: ", ";\n        background-size: ", ";\n        color: ", ";\n      "])), backgroundArg.image, backgroundArg.repeat || 'no-repeat', backgroundArg.position || 'center center', backgroundArg.size || 'cover', color));
    }

    if (backgroundArg.color) {
      var _color = (0, _color2.normalizeColor)(backgroundArg.color, theme);

      var backgroundColor = (0, _color2.getRGBA)(_color, backgroundArg.opacity === true ? theme.global.opacity.medium : theme.global.opacity[backgroundArg.opacity] || backgroundArg.opacity) || _color;

      styles.push((0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), backgroundColor));
    }

    return styles;
  }

  if (backgroundArg) {
    if (backgroundArg.lastIndexOf('url', 0) === 0) {
      return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background: ", " no-repeat center center;\n        background-size: cover;\n      "])), backgroundArg);
    }

    var _backgroundColor = (0, _color2.normalizeColor)(backgroundArg, theme);

    if (_backgroundColor) return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background: ", ";\n      "])), backgroundArg);
  }

  return undefined;
};

exports.backgroundStyle = backgroundStyle;
var activeStyle = (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return backgroundStyle((0, _color2.normalizeColor)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
exports.activeStyle = activeStyle;
var selectedStyle = (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return backgroundStyle((0, _color2.normalizeColor)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
exports.selectedStyle = selectedStyle;

var getHoverIndicatorStyle = function getHoverIndicatorStyle(hoverIndicator, theme) {
  var background;

  if (hoverIndicator === true || hoverIndicator === 'background') {
    background = theme.global.hover.background;
  } else {
    background = hoverIndicator;
  }

  return (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", "\n  "])), backgroundStyle(background, theme, theme.global.hover.color));
};

exports.getHoverIndicatorStyle = getHoverIndicatorStyle;